module.exports = __webpack_public_path__ + "img/16.f65c5879.jpg";